@import '~less/bootstrap/legacy-mixins';
@import '~less/global-variables';
@import './variables';

// Styled as 'mobile first'
.search-sidebar-container {
  .nav-tabs .nav-link {
    color: @text-color;

    &:hover,
    &:focus {
      color: @brand-primary;
    }
  }

  .nav-tabs .nav-link.active {
    color: @text-color;
    border-bottom-color: @brand-primary;
  }

  // Tabs are hidden on small screens
  // They are controlled via view controller JS instead
  @media (max-width: @screen-xs-max) {
    width: 100%;
    padding-top: 20px;
    .nav-tabs {
      display: none;
    }
  }

  // On small screens, don't show filters when offer is open
  &.is-offer-open {
    @media (max-width: @screen-xs-max) {
      .search-sidebar-filters {
        display: none;
      }
    }
  }
}

.search-sidebar-filters {
  // Adds extra space under filters so that any dropdowns fit open
  // E.g. language filter has a big dropdown
  padding-bottom: 250px;
}

// Push sidebar down a bit when sitewide announcements are visible.
// See `modules/core/client/less/layout/site-announcement.less` for more.
body.is-site-announcement-visible {
  .search-sidebar {
    top: @navbar-height + @site-announcement-height;
  }
}

.search-form-group {
  width: auto;
  margin-right: 0;
  .btn,
  input[type='text'],
  input[type='search'] {
    border-radius: 0;
    &,
    &:disabled,
    &:hover,
    &:active,
    &:focus {
      background: #fff;
      border-color: #eee;
      outline: none;
      box-shadow: none;
    }
  }
  input[type='text'],
  input[type='search'] {
    border-right: 0;
  }
  .btn {
    border-left: 0;
  }
}

.search-sidebar-section {
  margin: 10px;
  @media (min-width: @screen-sm-min) {
    margin: 15px;
  }
  border-bottom: 1px solid @gray-lighter;
  &:last-child {
    border-bottom: 0;
  }
}

.search-result,
.message-recipient {
  user-select: none;
  position: relative;
  cursor: pointer;
  .panel-body {
    display: block;
    border-left: 3px solid #fff;
    border-radius: @panel-border-radius;
    transition: all 0.1s linear;
    text-decoration: none;
    color: @text-color;
  }
  h4 {
    padding: 0;
    margin: 0;
  }
  .avatar {
    width: 36px;
    height: 36px;
    float: left;
    margin: 0 10px 0 0;
  }
  &.active,
  &:hover {
    .panel-body {
      border-color: @brand-primary;
    }
  }
  /* Notice . and : */
  &.active,
  &:active {
    background: #fafafa;
    .panel-body {
      border-color: @brand-secondary;
    }
  }
}

.search-result-list {
  list-style: none;
  margin: 0 10px 12px;
  padding: 0;

  li + li {
    margin-top: 6px;
  }
}

.search-result-list-item {
  align-items: center;
  color: @text-color;
  cursor: pointer;
  display: flex;
  gap: 10px;
  margin: 0;
  padding: 10px;
  text-align: left;
  transition:
    border-color 0.1s linear,
    background-color 0.1s linear;
  white-space: normal;
  width: 100%;

  &:hover {
    border-color: @brand-primary;
    background: #fafafa;
  }

  &:focus-visible {
    outline: 2px solid @brand-primary;
    outline-offset: 2px;
  }

  .avatar {
    flex: 0 0 36px;
    float: none;
    margin: 0;
  }

  > span {
    min-width: 0;
    overflow-wrap: anywhere;
  }
}

.search-results-back {
  margin: 0 10px 10px;
}

.search-result-label,
.search-result-languages h4 {
  .text-muted;
  font-size: @font-size-base;
  text-transform: uppercase;
}

.search-result-label {
  padding-bottom: 5px;
}

.search-result-languages {
  padding: 10px 0 0 0;
  &,
  h4 {
    font-size: @font-size-small;
  }
}

.search-result-meta {
  font-size: @font-size-small;
  .text-muted;
}

.search-result-tagline {
  margin: 0;
  padding: 10px 0;
  font-size: 15px;
}

.search-result-tribes-common {
  margin-top: 10px;
  font-size: @font-size-small;
  h4 {
    color: @gray-light;
    text-transform: uppercase;
    font-size: @font-size-base;
    line-height: @line-height-base;
  }
  a {
    color: @text-color;
  }
}

// Sidebar close toggle for small screens under filters and under profile
.search-sidebar-close {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
}
